import React from "react";
import { brandAssets } from "../../data/commerce";
import { LinkButton } from "../ui/Buttons";
import { FujiLine, Sakura } from "../ui/Decor";
const heroFacts = [{
  value: "7",
  label: "Tomos"
}, {
  value: "N5 → N4",
  label: "Progresión"
}, {
  value: "PDF",
  label: "Formato"
}];
const chips = ["Explicaciones en español", "Ebooks en PDF", "Base · Pro · Completo"];
export function Hero() {
  return <section id="inicio" aria-labelledby="hero-title" className="relative overflow-hidden scroll-mt-20" data-id="element-125" data-mp="2dkzom8vvxsd4">
      <FujiLine className="pointer-events-none absolute -right-24 top-6 hidden w-[560px] lg:block" data-id="element-126" data-mp="29i32i874ze4f" />
      <div className="relative mx-auto max-w-4xl px-4 pb-16 pt-12 text-center md:px-6 md:pb-24 md:pt-16" data-id="element-127" data-mp="24l48dpnh3768">
        <p className="flex items-center justify-center gap-2 text-sm font-semibold text-terracota-deep" data-id="element-128" data-mp="1zm9sowksxyqc">
          <Sakura className="h-3.5 w-3.5 text-terracota" data-id="element-129" data-mp="2s6c1juhlwgj" />
          Japonés desde cero · Ebooks en PDF
        </p>
        <h1 id="hero-title" className="mx-auto mt-4 max-w-3xl font-serif text-[2.4rem] font-medium leading-[1.06] tracking-tight text-pizarra-deep md:text-[4rem]" data-id="element-130" data-mp="3tzsjzoo8ol37">
          Dejá de juntar recursos sueltos. Empezá japonés con un camino claro.
        </h1>
        <figure className="relative mx-auto mt-10 max-w-2xl" data-id="element-131" data-mp="by7qjgica12o">
          <div className="overflow-hidden rounded-[28px] border border-pizarra/10 bg-crema shadow-[0_30px_60px_-30px_rgba(34,52,62,0.45)]" data-id="element-132" data-mp="gv7yjwyr1dwf">
            <img src={brandAssets.mockup} alt="Mockup del Megapack de Japonés: siete tomos principales y cinco bonos de kanji" className="aspect-square w-full object-cover" loading="eager" data-id="element-133" data-mp="14lu33e9jog1o" />
          </div>
          <figcaption className="absolute left-4 top-4 rounded-full bg-pizarra-deep/90 px-3.5 py-1.5 text-xs font-semibold text-marfil md:left-5 md:top-5 md:text-sm" data-id="element-134" data-mp="ztk8hkxhirt2">
            Contenido de los planes Pro y Completo
          </figcaption>
          <dl className="absolute inset-x-3 bottom-3 grid grid-cols-3 divide-x divide-marfil/20 rounded-2xl bg-pizarra-deep/90 py-3 text-marfil backdrop-blur md:inset-x-5 md:bottom-5" data-id="element-135" data-mp="1sczmg3ep1qgq">
            {heroFacts.map(f => <div key={f.label} className="px-2" data-id="element-136" data-mp="1s8flt27f2zvq">
                <dt className="sr-only" data-id="element-137" data-mp="1s74h9065do3k">{f.label}</dt>
                <dd className="font-serif text-xl font-medium md:text-2xl" data-id="element-138" data-mp="1o7dtl5bx3o39">{f.value}</dd>
                <dd className="text-xs text-crema md:text-sm" data-id="element-139" data-mp="1j811o666vqtt">{f.label}</dd>
              </div>)}
          </dl>
        </figure>
        <p className="mx-auto mt-10 max-w-2xl text-lg leading-relaxed text-pizarra md:text-xl" data-id="element-140" data-mp="1eg9f06q5m58y">
          Estudiá con 7 tomos progresivos, explicaciones en español y práctica organizada. Elegí sumar herramientas de
          kanji, japonés para viajes y un diccionario de 5.000 palabras.
        </p>
        <div className="mx-auto mt-8 flex max-w-md items-center justify-center gap-4 text-left" data-id="element-141" data-mp="10ghzg1jzogsu">
          <p className="whitespace-nowrap font-serif text-5xl font-medium text-dorado-deep" data-id="element-142" data-mp="vjhtdqn53e1q">
            7<span className="text-dorado" data-id="element-143" data-mp="374qnzf91a0l8">·</span>12<span className="text-dorado" data-id="element-144" data-mp="377waqnu6wqds">·</span>14
          </p>
          <div data-id="element-145" data-mp="3c3k1h7oblrle">
            <p className="font-semibold text-pizarra-deep" data-id="element-146" data-mp="3c3bqxmfo6ydd">Ebooks según tu plan</p>
            <p className="text-sm text-pizarra-soft" data-id="element-147" data-mp="3g7rtpetzlpod">Base, Pro o Completo · Contenidos de N5 y N4</p>
          </div>
        </div>
        <ul className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-148" data-mp="3l3gv7npkhgnb">
          {chips.map(c => <li key={c} className="rounded-full border border-pizarra/15 bg-papel/70 px-3.5 py-1.5 text-sm font-medium text-pizarra" data-id="element-149" data-mp="2od7ld9ix8ojq">
              {c}
            </li>)}
        </ul>
        <div className="mx-auto mt-9 flex max-w-xl flex-col items-stretch gap-3 sm:flex-row sm:justify-center" data-id="element-150" data-mp="2xenwxklh2wpj">
          <LinkButton href="#planes" withArrow className="sm:flex-1" data-id="element-151" data-mp="328jqmaupdxew">
            Quiero elegir mi megapack
          </LinkButton>
          <LinkButton href="#tomos" variant="secondary" data-id="element-152" data-mp="29pw9f6itv2j3">
            Ver qué incluye
          </LinkButton>
        </div>
        <p className="mt-4 text-sm text-pizarra-soft" data-id="element-153" data-mp="g8qk21uag2e3">Material digital en PDF. Para estudiar y consultar a tu ritmo.</p>
      </div>
    </section>;
}